import { render, staticRenderFns } from "./AddFee.vue?vue&type=template&id=b62efe64&"
import script from "./AddFee.vue?vue&type=script&lang=js&"
export * from "./AddFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports